import LinkedInRenderer from './LinkedInRenderer';
import TwitterRenderer from './TwitterRenderer';
import NewsletterRenderer from './NewsletterRenderer';
import PressReleaseRenderer from './PressReleaseRenderer';
import MarketingStrategistRenderer from './MarketingStrategistRenderer';
import SEOKeywordRenderer from './SEOKeywordRenderer';
import SEOContentRenderer from './SEOContentRenderer';

export const AGENT_RENDERERS = {
  linkedin_agent: LinkedInRenderer,
  twitter_agent: TwitterRenderer,
  newsletter_agent: NewsletterRenderer,
  press_release_agent: PressReleaseRenderer,
  marketing_strategist_agent: MarketingStrategistRenderer,
  seo_keyword_agent: SEOKeywordRenderer,
  seo_content_agent: SEOContentRenderer,
} as const;